import React from 'react';
import { CellData } from '../../types';

const CellWithDash = ({ value }: CellData) => {
  return <div>{value || '-'}</div>;
};
export default CellWithDash;
